import { Modal, ModalWidthEnum, useMediaSize } from 'Components/designSystem';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

import { setError } from '../store';

export default function AuthFailedDialog() {
    const { t } = useTranslation('auth');
    const dispatch = useDispatch();
    const errorMessage = useSelector((state: RootState) => state.auth.errorMessage);
    const errorCode = useSelector((state: RootState) => state.auth.errorCode);
    const { isMobile } = useMediaSize();
 
    if (!errorMessage || !errorCode) {
        return null;
    }

    const handleClose = () => {
        dispatch(setError(undefined));
    };

    return (
        <Modal title={ t('dialog.authFailed.title') }
            buttonAction={{
                action: handleClose,
                title: t('dialog.authFailed.close')
            }}
            width={ isMobile ? ModalWidthEnum.FULL : ModalWidthEnum.XS }
            onOverlayClick={ handleClose }
            open
        >
            { errorMessage }
        </Modal>
    );
}
